/**
 * Katalog kartu GEN-01 "Untuk Saya — Aksi Hari Ini" per role (DECISIONS D1: persis prototype `command-center.html`,
 * `W[me.role]` + `kartuAlm()`; evidence G1 §A). Satu-satunya daftar kartu per role — Phase 7 (M4) memindahkannya ke
 * pengaturan admin. Urutan = urutan tampil. Role di luar katalog memakai set Admin WH RM (prototype `W.admin_wh_rm`).
 */
export const COMMAND_CENTER_CARDS = {
  admin_wh_rm: [
    'karantina',
    'pr-run',
    'ng-open',
    'ro-run',
    'spk-open',
    'trf-requested',
    'disc-rm',
    'ng-move',
    'bap-ready',
    'notif'
  ],
  operator_wh_rm: ['my-qc', 'my-putaway', 'my-picking', 'my-opname'],
  wh_rm_supervisor: ['opn-validation-rm', 'pr-spv', 'ro-spv', 'sj-spv', 'karantina-run', 'picking-run', 'notif'],
  kadiv_wh_rm: ['ro-kadiv', 'sj-kadiv', 'wo-rm', 'rekap-harian', 'notif'],
  purchasing: ['pr-purch', 'ro-purch', 'notif'],
  tim_produksi: ['my-request', 'handover-ready', 'wip-pending', 'tobacco-today'],
  admin_wh_sansugi: ['sgi-requested', 'in-transit', 'sgi-putaway', 'notif'],
  admin_wh_fg: [
    'alm-pend',
    'alm-run',
    'pack-run',
    'batch-prod',
    'held',
    'terima-ifg05',
    'konsolidasi',
    'putaway-fg',
    'forecast',
    'staged',
    'claim',
    'disc-fg',
    'notif'
  ],
  operator_wh_fg: ['my-fg-putaway', 'my-fg-picking', 'my-rts', 'my-opname'],
  supervisor_wh_fg: [
    'alm-pantau',
    'alm-run',
    'batch-prod',
    'terima',
    'opn-validation-fg',
    'held',
    'release-spv',
    'order-released',
    'label-stock',
    'notif'
  ],
  kadiv_wh_fg: [
    'alm-run',
    'pack-run',
    'batch-prod',
    'terima',
    'wo-fg',
    'opn-fg-report',
    'label-stock',
    'inv03',
    'notif'
  ],
  sales_marketing: ['forecast-sales', 'claim-sales', 'notif']
} as const

export type CommandCenterRole = keyof typeof COMMAND_CENTER_CARDS
export type CommandCenterCardKey = (typeof COMMAND_CENTER_CARDS)[CommandCenterRole][number]

/** Role yang mendapat blok "Batch Penerimaan dari Auto Labeler" (prototype `almPeran`). */
export const COMMAND_CENTER_BATCH_ROLES = ['admin_wh_fg', 'supervisor_wh_fg', 'kadiv_wh_fg'] as const
